<template>
  <div
    class="ws-avatar"
    :style="{'background-image':`url(${_src})`}"
  >
    <RouterLink
      v-if="to"
      :to="to"
      class="ws-avatar__link"
    ></RouterLink>
  </div>
</template>

<script>
export default {
  computed: {
    _src() {
      return this.src ? this.src : require("@/__vue2stone_cms/img/wasajon.svg");
    },
  },
  props: {
    src: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: null,
    },
  },
};
</script>